import { isUndefined } from 'lodash';
import { Loader } from 'components/Loader';
import { LearningPathCtx } from 'domains/learning-path/context';
import { useLearningPath } from 'domains/learning-path/data';
import { LEARNING_PATH_STEPPER_STEP_IDS } from 'domains/learning-path/steps';
import { useCompletableWizard } from 'utils/hooks/useCompletableWizard';
import { LearningPathUI } from './ui';

type Props = {
  learningPathId: string;
  onSubmit: () => void;
};

export const LearningPath: React.FC<Props> = ({ learningPathId, onSubmit }) => {
  const { data, error, isLoading: isLoadingLearningPath } = useLearningPath(learningPathId);

  const wizard = useCompletableWizard(Object.keys(LEARNING_PATH_STEPPER_STEP_IDS).length);

  if (isLoadingLearningPath) {
    return <Loader defaultStyles />;
  }

  if (isUndefined(data)) {
    throw new Error(`Failed to fetch data for learning path ID: ${learningPathId}. Error was ${error}`);
  }

  return (
    <LearningPathCtx.Provider
      value={{
        ...wizard,
        learningPath: data,
        onComplete: onSubmit,
      }}
    >
      <LearningPathUI />
    </LearningPathCtx.Provider>
  );
};

export default LearningPath;
